import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next';
import { usePlanningActualState } from './Context/index';
import { checkArray } from '../../Components/helper';
import SalesTable from './Tables/SalesTable';
import SalesUnitsTable from './Tables/SalesUnitsTable';
import AverageSellPriceTable from './Tables/AverageSellPriceTable';
import OptionsTable from './Tables/OptionsTable';
import SalesPerOptionTable from './Tables/SalesPerOptionTable';
import CostOfSale from './Tables/CostOfSale';
import BuyingMargin from './Tables/BuyingMargin';
import MarginRate from './Tables/MarginRate';
import CashMargin from './Tables/CashMargin';
import Markdown from './Tables/Markdown';
import MarkdownPercent from './Tables/MarkdownPercent';
import SalesTableTotal from './Tables/SalesTableTotal';
import SalesUnitsTableTotal from './Tables/SalesUnitsTableTotal';
import AverageSellPriceTableTotal from './Tables/AverageSellPriceTableTotal';
import OptionsTableTotal from './Tables/OptionsTableTotal';
import SalesPerOptionTableTotal from './Tables/SalesPerOptionTableTotal';
import CostOfSaleTotal from './Tables/CostOfSaleTotal';
import BuyingMarginTotal from './Tables/BuyingMarginTotal';
import MarginRateTotal from './Tables/MarginRateTotal';
import CashMarginTotal from './Tables/CashMarginTotal';
import MarkdownTotal from './Tables/MarkdownTotal';
import MarkdownPercentTotal from './Tables/MarkdownPercentTotal';
import useCalculationHooks from './Hooks/useCalculationHooks';

function CompareYears({ categoryYear }) {
  const { calculateColumnsValues, calcualteVsDAta } = useCalculationHooks();
  const { planningActual, setPlanningActual } = usePlanningActualState();
  const { t } = useTranslation('common');
  const reducer = useSelector((reducerstate) => reducerstate);
  const { PlanningActualData } = reducer;
  const { yearsCompareReducer } = PlanningActualData;
  const [state, setState] = useState({
    year: null,
  });
  const { year } = state;
  const { yearsData, hideAllFields } = planningActual;

  useEffect(() => {
    let yearsArr = [categoryYear?.year];
    yearsArr = [...yearsArr, ...(categoryYear?.selectedCompareYears || [])];
    setState((prevState) => ({
      ...prevState,
      year: yearsArr,
    }));
  }, [categoryYear]);

  useEffect(() => {
    const init = async () => {
      if (!isEmpty(yearsCompareReducer)) {
        const main =
          yearsCompareReducer?.mainYear && (await calculateColumnsValues(yearsCompareReducer?.mainYear, yearsCompareReducer?.mainYear?.overallTotals));

        if (main) {
          main.allCategoryData.overallTotals = main.overallTotal;

          const otehrArray = [];
          for (const ele of yearsCompareReducer.compareYear) {
            const compareData = await calculateColumnsValues(ele, ele?.overallTotals);
            if (compareData) compareData.allCategoryData.overallTotals = compareData.overallTotal;

            otehrArray.push(compareData.allCategoryData);
          }
          console.log('otehrArray', otehrArray);
          await calcualteVsDAta(main?.allCategoryData, otehrArray);

          setPlanningActual((prevState) => ({
            ...prevState,
            yearsData: {
              mainYear: main.allCategoryData,
              compareYear: otehrArray,
              mainOvertotal: main.overallTotal,
            },
          }));
        } else {
          setPlanningActual((prevState) => ({
            ...prevState,
            yearsData: null,
          }));
        }
      }
    };

    init();
  }, [yearsCompareReducer]);

  return (
    !hideAllFields && (
      <div className="overflow-auto p-3">
        {!isEmpty(yearsCompareReducer) && yearsCompareReducer?.mainYear ? (
          <div className="d-flex compare-tbl-container">
            <SalesTableTotal years={year} />
            <SalesUnitsTableTotal years={year} />
            <AverageSellPriceTableTotal years={year} />
            <OptionsTableTotal years={year} />
            <SalesPerOptionTableTotal years={year} />
            <CostOfSaleTotal years={year} />
            <BuyingMarginTotal years={year} />
            <MarginRateTotal years={year} />
            <CashMarginTotal years={year} />
            <MarkdownTotal years={year} />
            <MarkdownPercentTotal years={year} />
          </div>
        ) : (
          <div>
            <p className="text-center mt-3">{t('PLANNING_ACTUAL.COMPARE_YEARS.NO_RECORD_FOUND')}</p>
          </div>
        )}
        {checkArray(yearsData?.mainYear?.category)
          ? yearsData.mainYear.category.map((catEle, i) => {
              return (
                <div key={catEle} className="d-flex compare-tbl-container">
                  <SalesTable key={i} years={year} categoryItem={catEle} />
                  <SalesUnitsTable key={i} years={year} categoryItem={catEle} />
                  <AverageSellPriceTable key={i} years={year} categoryItem={catEle} />
                  <OptionsTable key={i} years={year} categoryItem={catEle} />
                  <SalesPerOptionTable key={i} years={year} categoryItem={catEle} />
                  <CostOfSale key={i} years={year} categoryItem={catEle} />
                  <BuyingMargin key={i} years={year} categoryItem={catEle} />
                  <MarginRate key={i} years={year} categoryItem={catEle} />
                  <CashMargin key={i} years={year} categoryItem={catEle} />
                  <Markdown key={i} years={year} categoryItem={catEle} />
                  <MarkdownPercent key={i} years={year} categoryItem={catEle} />
                </div>
              );
            })
          : ''}
      </div>
    )
  );
}

export default CompareYears;
